import { MSL_TABLE_HEADER_SUBTEXT } from '@constants/commonConstants';
import TableHeader from '@molecules/msl/components/forecast/tableHeader';

function formatCurrencyWithoutCents(amount) {
  // Convert to number (ensure it handles cases like "0.000", "1200.00")
  const numericValue = parseFloat(amount); // Default to 0 if null or invalid
  // Handle the special case for 0.000 to show "$0"
  if (numericValue === 0) {
    return '$0';
  }
  // Remove the decimals by flooring the value to the nearest dollar
  const dollarsOnly = Math.floor(numericValue); // Truncate decimals
  // Format the number as currency with commas (US-style grouping)
  const formattedValue = dollarsOnly.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // Prepend the dollar sign
  return `$${formattedValue}`;
}

export const mslFooterColumnDefs = [
  {
    headerName: '',
    field: 'category',
    sortable: false,
    filter: false,
    suppressMenu: true,
    suppressMovable: true,
    minWidth: 520,
    hide: window.innerWidth < 600,
    cellStyle: { textAlign: 'left', fontWeight: 600, fontfamily: 'EYInterstate Light' },
    cellRenderer: 'msl_catagory_CellRenderer',
    tooltipField: 'category',
  },
  {
    headerName: 'Assurance',
    field: 'assurance',
    sortable: false,
    filter: false,
    suppressMenu: true,
    suppressMovable: true,
    minWidth: 150,
    hide: window.innerWidth < 600,
    headerComponent: TableHeader,
    headerComponentParams: {
      subText: MSL_TABLE_HEADER_SUBTEXT.EXCL_ACR,
      enableSorting: false,
      enableMenu: false,
      enableFilter: false,
    },
    tooltipValueGetter: params => {
      const value = params?.data?.assurance || 0;
      // Check if the category is "Your Judge" and the value is 0
      if (params?.data?.category === 'Your Judge' && value === 0) {
        return 'Add Judge'; // Show "Add Judge" in the tooltip
      }
      // Check if the category is 'Rolling 3 Fiscal Period Forecast Accuracy (PL + Audit/TR + GCSP)'
      if (
        params?.data?.category ===
        'Rolling 3 Fiscal Period Forecast Accuracy (PL + Audit/TR + GCSP)'
      ) {
        const truncatedValue = Math.floor(value); // Truncate decimals
        return `${truncatedValue}%`; // Return value with %
      }

      // For other categories, format as currency
      return formatCurrencyWithoutCents(value);
    },
    cellRenderer: 'msl_CellRenderer',
    cellRendererParams: () => {
      const KeyName = 'Assurance';
      return {
        KeyName,
      };
    },
    cellStyle: { textAlign: 'right' },
  },
  {
    headerName: 'Consulting',
    field: 'consulting',
    sortable: false,
    filter: false,
    suppressMenu: true,
    suppressMovable: true,
    tooltipValueGetter: params => {
      const value = params?.data?.consulting || 0;
      // Check if the category is "Your Judge" and the value is 0
      if (params?.data?.category === 'Your Judge' && value === 0) {
        return 'Add Judge'; // Show "Add Judge" in the tooltip
      }

      // Check if the category is 'Rolling 3 Fiscal Period Forecast Accuracy (PL + Audit/TR + GCSP)'
      if (
        params?.data?.category ===
        'Rolling 3 Fiscal Period Forecast Accuracy (PL + Audit/TR + GCSP)'
      ) {
        const truncatedValue = Math.floor(value); // Truncate decimals
        return `${truncatedValue}%`; // Return value with %
      }

      // For other categories, format as currency
      return formatCurrencyWithoutCents(value);
    },
    minWidth: 150,
    hide: window.innerWidth < 600,
    cellRenderer: 'msl_CellRenderer',
    cellRendererParams: () => {
      const KeyName = 'Consulting';
      return {
        KeyName,
      };
    },
    cellStyle: { textAlign: 'right' },
  },
  {
    headerName: 'SAT',
    field: 'sat',
    sortable: false,
    filter: false,
    suppressMenu: true,
    suppressMovable: true,
    tooltipValueGetter: params => {
      const value = params?.data?.sat || 0;
      // Check if the category is "Your Judge" and the value is 0
      if (params?.data?.category === 'Your Judge' && value === 0) {
        return 'Add Judge'; // Show "Add Judge" in the tooltip
      }
      // Check if the category is 'Rolling 3 Fiscal Period Forecast Accuracy (PL + Audit/TR + GCSP)'
      if (
        params?.data?.category ===
        'Rolling 3 Fiscal Period Forecast Accuracy (PL + Audit/TR + GCSP)'
      ) {
        const truncatedValue = Math.floor(value); // Truncate decimals
        return `${truncatedValue}%`; // Return value with %
      }

      // For other categories, format as currency
      return formatCurrencyWithoutCents(value);
    },
    minWidth: 150,
    hide: window.innerWidth < 600,
    headerComponent: TableHeader,
    headerComponentParams: {
      subText: MSL_TABLE_HEADER_SUBTEXT.EXCL_SAT,
      enableSorting: false,
      enableMenu: false,
      enableFilter: false,
    },
    cellRenderer: 'msl_CellRenderer',
    cellRendererParams: () => {
      const KeyName = 'SAT';
      return {
        KeyName,
      };
    },
    cellStyle: { textAlign: 'right' },
  },
  {
    headerName: 'Tax',
    field: 'tax',
    sortable: false,
    filter: false,
    suppressMenu: true,
    suppressMovable: true,
    tooltipValueGetter: params => {
      const value = params?.data?.tax || 0;
      // Check if the category is "Your Judge" and the value is 0
      if (params?.data?.category === 'Your Judge' && value === 0) {
        return 'Add Judge'; // Show "Add Judge" in the tooltip
      }
      // Check if the category is 'Rolling 3 Fiscal Period Forecast Accuracy (PL + Audit/TR + GCSP)'
      if (
        params?.data?.category ===
        'Rolling 3 Fiscal Period Forecast Accuracy (PL + Audit/TR + GCSP)'
      ) {
        const truncatedValue = Math.floor(value); // Truncate decimals
        return `${truncatedValue}%`; // Return value with %
      }

      // For other categories, format as currency
      return formatCurrencyWithoutCents(value);
    },
    minWidth: 150,
    hide: window.innerWidth < 600,
    headerComponent: TableHeader,
    headerComponentParams: {
      subText: MSL_TABLE_HEADER_SUBTEXT.EXCL_TAX,
      enableSorting: false,
      enableMenu: false,
      enableFilter: false,
    },
    cellRenderer: 'msl_CellRenderer',
    cellRendererParams: () => {
      const KeyName = 'Tax';
      return {
        KeyName,
      };
    },
    cellStyle: { textAlign: 'right' },
  },
  {
    headerName: 'ITTS',
    field: 'itts',
    sortable: false,
    filter: false,
    suppressMenu: true,
    suppressMovable: true,
    tooltipValueGetter: params => {
      const value = params?.data?.itts || 0;
      // Check if the category is "Your Judge" and the value is 0
      if (params?.data?.category === 'Your Judge' && value === 0) {
        return 'Add Judge'; // Show "Add Judge" in the tooltip
      }
      // Check if the category is 'Rolling 3 Fiscal Period Forecast Accuracy (PL + Audit/TR + GCSP)'
      if (
        params?.data?.category ===
        'Rolling 3 Fiscal Period Forecast Accuracy (PL + Audit/TR + GCSP)'
      ) {
        const truncatedValue = Math.floor(value); // Truncate decimals
        return `${truncatedValue}%`; // Return value with %
      }

      // For other categories, format as currency
      return formatCurrencyWithoutCents(value);
    },
    minWidth: 150,
    hide: window.innerWidth < 600,
    cellRenderer: 'msl_CellRenderer',
    cellRendererParams: () => {
      const KeyName = 'ITTS';
      return {
        KeyName,
      };
    },
    cellStyle: { textAlign: 'right' },
  },
  {
    headerName: 'EMEIA ACR',
    field: 'emeia',
    sortable: false,
    filter: false,
    suppressMenu: true,
    suppressMovable: true,
    tooltipValueGetter: params => {
      const value = params?.data?.emeia || 0;
      // Check if the category is "Your Judge" and the value is 0
      if (params?.data?.category === 'Your Judge' && value === 0) {
        return 'Add Judge'; // Show "Add Judge" in the tooltip
      }
      // Check if the category is 'Rolling 3 Fiscal Period Forecast Accuracy (PL + Audit/TR + GCSP)'
      if (
        params?.data?.category ===
        'Rolling 3 Fiscal Period Forecast Accuracy (PL + Audit/TR + GCSP)'
      ) {
        const truncatedValue = Math.floor(value); // Truncate decimals
        return `${truncatedValue}%`; // Return value with %
      }

      // For other categories, format as currency
      return formatCurrencyWithoutCents(value);
    },
    minWidth: 150,
    hide: window.innerWidth < 600,
    cellRenderer: 'msl_CellRenderer',
    cellRendererParams: () => {
      const KeyName = 'EMEIA';
      return {
        KeyName,
      };
    },
    cellStyle: { textAlign: 'right' },
  },
  {
    headerName: 'Total',
    field: 'total',
    sortable: false,
    filter: false,
    suppressMenu: true,
    suppressMovable: true,
    tooltipValueGetter: params => {
      const value = params?.data?.total || 0;
      // Check if the category is "Your Judge" and the value is 0
      if (params?.data?.category === 'Your Judge' && value === 0) {
        return 'Add Judge'; // Show "Add Judge" in the tooltip
      }
      // Check if the category is 'Rolling 3 Fiscal Period Forecast Accuracy (PL + Audit/TR + GCSP)'
      if (
        params?.data?.category ===
        'Rolling 3 Fiscal Period Forecast Accuracy (PL + Audit/TR + GCSP)'
      ) {
        const truncatedValue = Math.floor(value); // Truncate decimals
        return `${truncatedValue}%`; // Return value with %
      }

      // For other categories, format as currency
      return formatCurrencyWithoutCents(value);
    },
    minWidth: 150,
    hide: window.innerWidth < 600,
    cellRenderer: 'msl_CellRenderer',
    cellRendererParams: () => {
      const KeyName = 'Total';
      return {
        KeyName,
      };
    },
    cellStyle: { textAlign: 'right', fontWeight: 'bold' },
  },
];
